import React, { useId } from 'react';
import { CardArtwork } from './WalletUI.js';
import { CryptoIcon } from './CryptoIcon.js';

export const CryptoCardHero: React.FC = () => {
  const streamId = `funding-stream-${useId().replace(/:/g, '')}`;
  const flows = [
    { coin: 'bitcoin', path: 'M100 58C98 98 119 120 156 132' },
    { coin: 'tether', path: 'M448 377C416 375 403 350 409 315' },
  ];
  return (
    <div className="hero-art crypto-card-hero">
      <div className="orbital-ring ring-one" aria-hidden="true" />
      <svg className="hero-funding-paths" viewBox="0 0 500 440" fill="none" aria-hidden="true">
        {flows.map(({ coin, path }) => (
          <g key={coin} className={`funding-flow funding-flow-${coin}`}>
            <defs>
              <linearGradient id={`${streamId}-${coin}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="var(--flow-color)" stopOpacity="0.05" />
                <stop offset="0.5" stopColor="var(--flow-color)" stopOpacity="0.8" />
                <stop offset="1" stopColor="var(--flow-color)" stopOpacity="0.08" />
              </linearGradient>
            </defs>
            <path
              className="funding-ribbon"
              d={path}
              pathLength="100"
              stroke={`url(#${streamId}-${coin})`}
            />
            <path className="funding-rail" d={path} pathLength="100" />
            <path className="funding-sweep funding-sweep-halo" d={path} pathLength="100" />
            <path className="funding-sweep funding-sweep-core" d={path} pathLength="100" />
          </g>
        ))}
      </svg>
      <div className="hero-coin ethereum-coin" role="img" aria-label="Ethereum coin illustration">
        <span className="coin-face" aria-hidden="true">
          <CryptoIcon coin="ethereum" size={68} />
        </span>
      </div>
      <div className="hero-coin bitcoin-coin" role="img" aria-label="Bitcoin coin illustration">
        <span className="coin-face" aria-hidden="true">
          <CryptoIcon coin="bitcoin" size={92} />
        </span>
      </div>
      <div className="hero-card">
        <CardArtwork showEdition={false} />
      </div>
      <div className="hero-coin tether-coin" role="img" aria-label="Tether USDT coin illustration">
        <span className="coin-face" aria-hidden="true">
          <CryptoIcon coin="tether" size={92} />
        </span>
      </div>
      <div className="hero-conversion-label">
        <span>CRYPTO</span>
        <span aria-hidden="true">→</span>
        <span>BALANCE</span>
        <span aria-hidden="true">→</span>
        <span>CARD</span>
      </div>
    </div>
  );
};
